// extracted by mini-css-extract-plugin
export var arrow = "tooltip-module--arrow--2e87c";
export var tooltip = "tooltip-module--tooltip--c9198";
export var tooltipTrigger = "tooltip-module--tooltipTrigger--92541";